import { useState } from "react";
import { downloadFile } from "@/lib/upload";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { FileText, FileDown, Printer } from "lucide-react";

const SIZES = [["f4", "F4 (215×330mm)"], ["a4", "A4 (210×297mm)"]];
const ORIENTS = [["portrait", "Potret"], ["landscape", "Lanskap"]];

export default function PrintExportDialog({ open, onClose, title = "Cetak / Unduh", baseUrl, filenameBase }) {
  const [size, setSize] = useState("f4");
  const [orient, setOrient] = useState("portrait");
  const dl = (fmt) => {
    const ext = fmt === "excel" ? "xlsx" : "pdf";
    downloadFile(`${baseUrl}?format=${fmt}&size=${size}&orientation=${orient}`, `${filenameBase}_${size.toUpperCase()}_${orient}.${ext}`);
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm" data-testid="print-export-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Printer className="h-5 w-5 text-emerald-700" /> {title}</DialogTitle><DialogDescription>Pilih ukuran kertas & orientasi, lalu unduh.</DialogDescription></DialogHeader>
        <div className="space-y-4 py-1">
          <div className="space-y-1.5">
            <Label className="text-xs">Ukuran Kertas</Label>
            <div className="grid grid-cols-2 gap-2">
              {SIZES.map(([v, l]) => (
                <button key={v} data-testid={`print-size-${v}`} onClick={() => setSize(v)}
                  className={`rounded-xl border px-3 py-2 text-sm font-semibold transition-colors ${size === v ? "bg-emerald-700 text-white border-emerald-700" : "bg-white/60 text-emerald-800 border-emerald-200 hover:bg-emerald-50"}`}>{l}</button>
              ))}
            </div>
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Orientasi</Label>
            <div className="grid grid-cols-2 gap-2">
              {ORIENTS.map(([v, l]) => (
                <button key={v} data-testid={`print-orient-${v}`} onClick={() => setOrient(v)}
                  className={`rounded-xl border px-3 py-2 text-sm font-semibold transition-colors ${orient === v ? "bg-emerald-700 text-white border-emerald-700" : "bg-white/60 text-emerald-800 border-emerald-200 hover:bg-emerald-50"}`}>{l}</button>
              ))}
            </div>
          </div>
          <p className="text-[11px] text-slate-400">PDF akan otomatis terunduh sesuai ukuran & orientasi yang dipilih.</p>
        </div>
        <DialogFooter className="flex-wrap gap-2">
          <Button variant="outline" className="gap-2" data-testid="print-download-excel" onClick={() => dl("excel")}><FileDown className="h-4 w-4" /> Excel</Button>
          <Button className="gap-2 bg-emerald-700 hover:bg-emerald-800" data-testid="print-download-pdf" onClick={() => dl("pdf")}><FileText className="h-4 w-4" /> Unduh PDF</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
